import React from 'react';
import Chip from '@mui/material/Chip';
import EventBusyOutlinedIcon from '@mui/icons-material/EventBusyOutlined';
import { formatClosureShortDate } from '../../../../components/company-closure/companyClosure';

const STYLES = {
  grace: { backgroundColor: '#FFF3E0', color: '#E65100' },
  expired: { backgroundColor: '#FDECEA', color: '#B71C1C' },
};

/**
 * CompanyClosureChip - Situação do encerramento da conta (Admin Geral)
 * "Em encerramento até dd/mm" durante a carência e "Carência vencida" depois dela.
 * @param {Object} props
 * @param {string|null} props.state - 'grace' | 'expired' (outros valores não exibem nada)
 * @param {string|null} props.scheduledAt
 */
function CompanyClosureChip({ state, scheduledAt }) {
  if (state !== 'grace' && state !== 'expired') return null;

  const date = formatClosureShortDate(scheduledAt);
  const label = state === 'expired'
    ? 'Carência vencida'
    : `Em encerramento${date ? ` até ${date}` : ''}`;

  return (
    <Chip
      size="small"
      icon={<EventBusyOutlinedIcon sx={{ fontSize: '14px !important', color: 'inherit !important' }} />}
      label={label}
      sx={{
        ...STYLES[state],
        fontWeight: 500,
        '& .MuiChip-label': { px: 1 },
      }}
    />
  );
}

export default CompanyClosureChip;
